import React, { useState } from "react";
import { createSelfServiceOrganization } from "../helpers/organizationHelpers";
import { OrganizationJoinScreen } from "./OrganizationJoinScreen";
import "./admin/adminDesktop.css";

/**
 * First-run gate for authenticated users without org membership.
 * A1: create your own company (you become its Organization Owner) or join an existing one by invite / join code.
 */
function CreateOrganizationForm({ onComplete, createOrganization }) {
  const [companyName, setCompanyName] = useState("");
  const [ownerName, setOwnerName] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    if (busy) return;
    setError("");
    setBusy(true);
    try {
      const { error: createError } = await createOrganization({ companyName, ownerName });
      if (createError) {
        setError(createError.message);
        return;
      }
      onComplete?.();
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} aria-label="Create your company" style={{ marginBottom: "20px" }}>
      <h2 style={{ fontSize: "18px", marginBottom: "8px" }}>Create your company</h2>
      <p style={{ opacity: 0.8, fontSize: "14px", marginBottom: "10px" }}>
        You will be the Organization Owner with full administrative access.
      </p>
      <label style={{ display: "block", marginBottom: "8px" }}>
        Company name
        <input
          className="nx-input"
          value={companyName}
          maxLength={120}
          onChange={(e) => setCompanyName(e.target.value)}
          style={{ display: "block", width: "100%" }}
        />
      </label>
      <label style={{ display: "block", marginBottom: "8px" }}>
        Your name
        <input
          className="nx-input"
          value={ownerName}
          maxLength={120}
          onChange={(e) => setOwnerName(e.target.value)}
          style={{ display: "block", width: "100%" }}
        />
      </label>
      {error && (
        <p role="alert" style={{ color: "#ff9b9b", fontSize: "14px" }}>
          {error}
        </p>
      )}
      <button type="submit" className="nx-btn nx-btn-primary" disabled={busy || companyName.trim().length < 2}>
        {busy ? "Creating…" : "Create company"}
      </button>
    </form>
  );
}

export function OrgSetupScreen({ userEmail, onComplete, onSignOut, createOrganization = createSelfServiceOrganization }) {
  return (
    <div className="app nx-app">
      <div
        className="adm-orgsetup"
        style={{
          maxWidth: "560px",
          margin: "0 auto",
          padding: "24px 16px 0",
          color: "#e8ecf4",
        }}
      >
        <h1 className="adm-orgsetup__title" style={{ fontSize: "22px", marginBottom: "8px" }}>
          Set up CrewPilot
        </h1>
        <p style={{ opacity: 0.85, lineHeight: 1.5, marginBottom: "8px" }}>
          {userEmail ? (
            <>
              Signed in as <strong>{userEmail}</strong>.
            </>
          ) : (
            <>You are signed in.</>
          )}{" "}
          Create your company, or join your team's organization with an
          invitation or join code.
        </p>
        {onSignOut && (
          <button
            type="button"
            className="nx-btn nx-btn-ghost"
            style={{ marginBottom: "8px" }}
            onClick={onSignOut}
          >
            Sign out
          </button>
        )}
        <CreateOrganizationForm onComplete={onComplete} createOrganization={createOrganization} />
        <h2 style={{ fontSize: "18px", margin: "8px 0" }}>Join an existing organization</h2>
      </div>
      <OrganizationJoinScreen onComplete={onComplete} />
    </div>
  );
}
